<section id="about" class="section pt-28 sm:pt-32" appReveal>
  <div class="grid items-center gap-10 lg:grid-cols-[1.6fr_1fr]">
    <!-- Intro -->
    <div>
      <p class="eyebrow mb-4">{{ about.address }}</p>
      <h1 class="text-4xl font-extrabold tracking-tight sm:text-5xl">
        {{ about.name }} {{ about.surname }}
        <span class="text-cyan-500"><i class="fab fa-aws"></i></span>
      </h1>

      <p class="mt-6 max-w-2xl whitespace-pre-line text-base leading-relaxed text-slate-600 dark:text-slate-300">
        {{ about.summary }}
      </p>

      <!-- CTAs -->
      <div class="mt-8 flex flex-wrap items-center gap-3">
        <a
          class="btn btn-accent"
          href="https://mail.google.com/mail/?view=cm&fs=1&to=ozan.senturk@gmail.com&su=Hello%20Ozan"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fas fa-envelope"></i> Get in touch
        </a>
        <a class="btn btn-ghost" [href]="about.linkedin" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-linkedin-in"></i> LinkedIn
        </a>
      </div>

      <!-- Socials -->
      <div class="mt-6 flex items-center gap-4 text-lg">
        <a class="link-muted" [href]="about.linkedin" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
        <a class="link-muted" [href]="about.github" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><i class="fab fa-github"></i></a>
        <a class="link-muted" [href]="about.docker" target="_blank" rel="noopener noreferrer" aria-label="Docker"><i class="fab fa-docker"></i></a>
        <a *ngIf="about.twitter" class="link-muted" [href]="about.twitter" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
      </div>
    </div>

    <!-- Avatar -->
    <div class="order-first flex justify-center lg:order-last">
      <div class="relative">
        <div class="absolute -inset-3 rounded-full bg-gradient-to-tr from-cyan-500/30 to-indigo-500/20 blur-2xl"></div>
        <img
          src="assets/img/profile-03.jpg"
          alt="{{ about.name }} {{ about.surname }}"
          class="relative h-44 w-44 rounded-full object-cover ring-4 ring-white shadow-xl sm:h-56 sm:w-56 dark:ring-white/10"
        />
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer class="mt-20 border-t border-slate-200 pt-6 text-center text-sm text-slate-500 dark:border-white/10 dark:text-slate-400">
    <a class="link-muted" href="https://choosealicense.com/licenses/mit/">MIT License</a>
    &nbsp;·&nbsp;
    © 2026-2027 <a class="link-muted" href="http://www.quantifai.co.uk">Quantif<strong>ai</strong> Ltd.</a>
  </footer>
</section>
